import type {
  MockClient,
  MockDocument,
  TaxRequestJob,
  FolderNode,
} from "./types";

export const mockClients: MockClient[] = [
  { id: "c1", name: "Фирма Алфа ЕООД", eik: "123456789" },
  { id: "c2", name: "Бета Трейдинг ООД", eik: "987654321" },
  { id: "c3", name: "Гама Сървисис АД", eik: "112233445" },
  { id: "c4", name: "Делта Консулт ЕООД", eik: "556677889" },
];

export const folderTree: FolderNode[] = [
  {
    id: "invoices",
    label: "Invoices",
    path: "invoices",
    children: [
      { id: "invoices-inbound", label: "Inbound", path: "invoices/inbound" },
      { id: "invoices-outbound", label: "Outbound", path: "invoices/outbound" },
    ],
  },
  { id: "contracts", label: "Contracts", path: "contracts" },
  { id: "bank-statements", label: "Bank Statements", path: "bank-statements" },
  { id: "annexes", label: "Annexes", path: "annexes" },
  { id: "agreements", label: "Agreements", path: "agreements" },
  { id: "other", label: "Other", path: "other" },
];

export const mockDocuments: MockDocument[] = [
  {
    id: "d1",
    originalFilename: "scan_001.pdf",
    storedFilename: "2025-01-15-F0001234-Alfa-Supplies.pdf",
    documentType: "invoice_inbound",
    documentDate: "2025-01-15",
    uploadDate: "2025-01-16",
    counterpartyName: "Алфа Сплайс ООД",
    counterpartyEik: "200100300",
    amount: 2400.0,
    currency: "BGN",
    status: "processed",
    clientId: "c1",
    folder: "invoices/inbound",
    aiConfidence: 0.97,
    description: "Доставка на офис консумативи",
  },
  {
    id: "d2",
    originalFilename: "invoice_feb.pdf",
    storedFilename: "2025-02-03-F0001567-Omega-Tech.pdf",
    documentType: "invoice_inbound",
    documentDate: "2025-02-03",
    uploadDate: "2025-02-04",
    counterpartyName: "Омега Тех ЕООД",
    counterpartyEik: "300200100",
    amount: 5600.0,
    currency: "EUR",
    status: "processed",
    clientId: "c1",
    folder: "invoices/inbound",
    aiConfidence: 0.94,
    description: "IT оборудване - лаптопи",
  },
  {
    id: "d3",
    originalFilename: "issued_inv_0089.pdf",
    storedFilename: "2025-01-20-F0089-Beta-Trading.pdf",
    documentType: "invoice_outbound",
    documentDate: "2025-01-20",
    uploadDate: "2025-01-20",
    counterpartyName: "Бета Трейдинг ООД",
    counterpartyEik: "987654321",
    amount: 12000.0,
    currency: "BGN",
    status: "processed",
    clientId: "c1",
    folder: "invoices/outbound",
    aiConfidence: 0.99,
    description: "Консултантски услуги - януари 2025",
  },
  {
    id: "d4",
    originalFilename: "contract_naem.pdf",
    storedFilename: "2024-06-01-Dogovor-Naem-Gamma.pdf",
    documentType: "contract",
    documentDate: "2024-06-01",
    uploadDate: "2024-06-02",
    counterpartyName: "Гама Сървисис АД",
    counterpartyEik: "112233445",
    amount: 2500.0,
    currency: "BGN",
    status: "processed",
    clientId: "c1",
    folder: "contracts",
    aiConfidence: 0.92,
    description: "Договор за наем на офис - 2 години",
  },
  {
    id: "d5",
    originalFilename: "bank_jan_2025.pdf",
    storedFilename: "2025-01-31-Izvlechenie-UniCredit-012025.pdf",
    documentType: "bank_statement",
    documentDate: "2025-01-31",
    uploadDate: "2025-02-01",
    counterpartyName: "УниКредит Булбанк",
    counterpartyEik: "831919536",
    amount: 0,
    currency: "BGN",
    status: "processed",
    clientId: "c1",
    folder: "bank-statements",
    aiConfidence: 0.88,
    description: "Банково извлечение Януари 2025",
  },
  {
    id: "d6",
    originalFilename: "aneks_1.pdf",
    storedFilename: "2024-12-15-Aneks-1-Dogovor-Naem.pdf",
    documentType: "annex",
    documentDate: "2024-12-15",
    uploadDate: "2024-12-16",
    counterpartyName: "Гама Сървисис АД",
    counterpartyEik: "112233445",
    amount: 2800.0,
    currency: "BGN",
    status: "processed",
    clientId: "c1",
    folder: "annexes",
    aiConfidence: 0.91,
    description: "Анекс 1 - увеличение на наема",
  },
  // Client c2 - Бета Трейдинг
  {
    id: "d7",
    originalFilename: "amazon_de_vat.pdf",
    storedFilename: "2025-01-10-VAT-Invoice-Amazon-DE.pdf",
    documentType: "invoice_inbound",
    documentDate: "2025-01-10",
    uploadDate: "2025-01-12",
    counterpartyName: "Amazon EU S.a.r.l.",
    counterpartyEik: "LU26375245",
    amount: 890.5,
    currency: "EUR",
    status: "processed",
    clientId: "c2",
    folder: "invoices/inbound",
    aiConfidence: 0.96,
    description: "Amazon DE VAT фактура - рекламни разходи",
  },
  {
    id: "d8",
    originalFilename: "stripe_jan.pdf",
    storedFilename: "2025-01-31-Stripe-Payout-012025.pdf",
    documentType: "invoice_inbound",
    documentDate: "2025-01-31",
    uploadDate: "2025-02-01",
    counterpartyName: "Stripe Payments Europe",
    counterpartyEik: "IE3206488LH",
    amount: 3450.0,
    currency: "EUR",
    status: "processed",
    clientId: "c2",
    folder: "invoices/inbound",
    aiConfidence: 0.93,
    description: "Stripe отчет за изплащания Януари",
  },
  {
    id: "d9",
    originalFilename: "dogovor_shopify.pdf",
    storedFilename: "2024-03-01-Agreement-Shopify-Partner.pdf",
    documentType: "agreement",
    documentDate: "2024-03-01",
    uploadDate: "2024-03-02",
    counterpartyName: "Shopify Inc.",
    counterpartyEik: "CA845967",
    amount: 0,
    currency: "USD",
    status: "processed",
    clientId: "c2",
    folder: "agreements",
    aiConfidence: 0.87,
    description: "Партньорско споразумение с Shopify",
  },
  {
    id: "d10",
    originalFilename: "revolut_feb.pdf",
    storedFilename: "2025-02-28-Izvlechenie-Revolut-022025.pdf",
    documentType: "bank_statement",
    documentDate: "2025-02-28",
    uploadDate: "2025-03-01",
    counterpartyName: "Revolut Ltd",
    counterpartyEik: "GB09740195",
    amount: 0,
    currency: "EUR",
    status: "processed",
    clientId: "c2",
    folder: "bank-statements",
    aiConfidence: 0.9,
    description: "Revolut извлечение Февруари 2025",
  },
  {
    id: "d11",
    originalFilename: "sale_inv_0234.pdf",
    storedFilename: "2025-02-15-F0234-Client-XYZ.pdf",
    documentType: "invoice_outbound",
    documentDate: "2025-02-15",
    uploadDate: "2025-02-15",
    counterpartyName: "XYZ Commerce GmbH",
    counterpartyEik: "DE301234567",
    amount: 18500.0,
    currency: "EUR",
    status: "processed",
    clientId: "c2",
    folder: "invoices/outbound",
    aiConfidence: 0.98,
    description: "Продажба на стоки - февруари 2025",
  },
  // Client c3 - Гама Сървисис
  {
    id: "d12",
    originalFilename: "scan_reception.jpg",
    storedFilename: "2025-03-01-F0078-Office-Depot.pdf",
    documentType: "invoice_inbound",
    documentDate: "2025-03-01",
    uploadDate: "2025-03-02",
    counterpartyName: "Office Depot България",
    counterpartyEik: "175346937",
    amount: 780.0,
    currency: "BGN",
    status: "processing",
    clientId: "c3",
    folder: "invoices/inbound",
    aiConfidence: 0,
    description: "",
  },
  {
    id: "d13",
    originalFilename: "dogovor_it_support.pdf",
    storedFilename: "2025-01-01-Dogovor-IT-Support-Alfa.pdf",
    documentType: "contract",
    documentDate: "2025-01-01",
    uploadDate: "2025-01-02",
    counterpartyName: "Фирма Алфа ЕООД",
    counterpartyEik: "123456789",
    amount: 1200.0,
    currency: "BGN",
    status: "processed",
    clientId: "c3",
    folder: "contracts",
    aiConfidence: 0.95,
    description: "Договор за IT поддръжка - 12 месеца",
  },
  {
    id: "d14",
    originalFilename: "corrupted_scan.tiff",
    storedFilename: "corrupted_scan.tiff",
    documentType: "other",
    documentDate: "2025-02-20",
    uploadDate: "2025-02-20",
    counterpartyName: "",
    counterpartyEik: "",
    amount: 0,
    currency: "BGN",
    status: "failed",
    clientId: "c3",
    folder: "other",
    aiConfidence: 0,
    description: "",
  },
  {
    id: "d15",
    originalFilename: "bank_dsk_mar.pdf",
    storedFilename: "2025-03-15-Izvlechenie-DSK-032025.pdf",
    documentType: "bank_statement",
    documentDate: "2025-03-15",
    uploadDate: "2025-03-16",
    counterpartyName: "Банка ДСК",
    counterpartyEik: "121830616",
    amount: 0,
    currency: "BGN",
    status: "processed",
    clientId: "c3",
    folder: "bank-statements",
    aiConfidence: 0.86,
    description: "Банково извлечение ДСК Март 2025",
  },
  // Client c4 - Делта Консулт
  {
    id: "d16",
    originalFilename: "inv_from_alfa.pdf",
    storedFilename: "2025-03-10-F0091-Firma-Alfa.pdf",
    documentType: "invoice_inbound",
    documentDate: "2025-03-10",
    uploadDate: "2025-03-11",
    counterpartyName: "Фирма Алфа ЕООД",
    counterpartyEik: "123456789",
    amount: 4500.0,
    currency: "BGN",
    status: "processed",
    clientId: "c4",
    folder: "invoices/inbound",
    aiConfidence: 0.96,
    description: "Консултантски услуги от Алфа",
  },
  {
    id: "d17",
    originalFilename: "sporazumenie_nda.pdf",
    storedFilename: "2024-09-01-NDA-Alfa-Delta.pdf",
    documentType: "agreement",
    documentDate: "2024-09-01",
    uploadDate: "2024-09-02",
    counterpartyName: "Фирма Алфа ЕООД",
    counterpartyEik: "123456789",
    amount: 0,
    currency: "BGN",
    status: "processed",
    clientId: "c4",
    folder: "agreements",
    aiConfidence: 0.89,
    description: "Споразумение за конфиденциалност (NDA)",
  },
  {
    id: "d18",
    originalFilename: "new_upload.pdf",
    storedFilename: "",
    documentType: "invoice_inbound",
    documentDate: "2025-03-25",
    uploadDate: "2025-03-27",
    counterpartyName: "",
    counterpartyEik: "",
    amount: 0,
    currency: "BGN",
    status: "processing",
    clientId: "c4",
    folder: "invoices/inbound",
    aiConfidence: 0,
    description: "",
  },
];

export const mockTaxRequestJobs: TaxRequestJob[] = [
  {
    id: "tr1",
    clientId: "c1",
    requestFilename: "NAP_Iskane_2025_001.pdf",
    requestDate: "2025-03-20",
    status: "completed",
    totalRequested: 6,
    totalFound: 6,
    totalMissing: 0,
    totalAmbiguous: 0,
    items: [
      {
        id: "tr1-i1",
        requestedDescription: "Фактура №0001234 от 15.01.2025 от Алфа Сплайс ООД",
        requestedDocumentType: "invoice_inbound",
        requestedDocumentNumber: "0001234",
        requestedDocumentDate: "2025-01-15",
        requestedCounterparty: "Алфа Сплайс ООД",
        status: "found",
        matchedDocumentId: "d1",
        matchNotes: null,
        candidateDocumentIds: [],
      },
      {
        id: "tr1-i2",
        requestedDescription: "Фактура №0001567 от 03.02.2025 от Омега Тех ЕООД",
        requestedDocumentType: "invoice_inbound",
        requestedDocumentNumber: "0001567",
        requestedDocumentDate: "2025-02-03",
        requestedCounterparty: "Омега Тех ЕООД",
        status: "found",
        matchedDocumentId: "d2",
        matchNotes: null,
        candidateDocumentIds: [],
      },
      {
        id: "tr1-i3",
        requestedDescription: "Издадена фактура №0089 от 20.01.2025 към Бета Трейдинг",
        requestedDocumentType: "invoice_outbound",
        requestedDocumentNumber: "0089",
        requestedDocumentDate: "2025-01-20",
        requestedCounterparty: "Бета Трейдинг ООД",
        status: "found",
        matchedDocumentId: "d3",
        matchNotes: null,
        candidateDocumentIds: [],
      },
      {
        id: "tr1-i4",
        requestedDescription: "Договор за наем с Гама Сървисис АД",
        requestedDocumentType: "contract",
        requestedDocumentNumber: null,
        requestedDocumentDate: null,
        requestedCounterparty: "Гама Сървисис АД",
        status: "found",
        matchedDocumentId: "d4",
        matchNotes: null,
        candidateDocumentIds: [],
      },
      {
        id: "tr1-i5",
        requestedDescription: "Банково извлечение за Януари 2025",
        requestedDocumentType: "bank_statement",
        requestedDocumentNumber: null,
        requestedDocumentDate: "2025-01-31",
        requestedCounterparty: null,
        status: "found",
        matchedDocumentId: "d5",
        matchNotes: null,
        candidateDocumentIds: [],
      },
      {
        id: "tr1-i6",
        requestedDescription: "Анекс към договор за наем с Гама Сървисис",
        requestedDocumentType: "annex",
        requestedDocumentNumber: null,
        requestedDocumentDate: null,
        requestedCounterparty: "Гама Сървисис АД",
        status: "found",
        matchedDocumentId: "d6",
        matchNotes: null,
        candidateDocumentIds: [],
      },
    ],
  },
  {
    id: "tr2",
    clientId: "c2",
    requestFilename: "NAP_Iskane_2025_014.pdf",
    requestDate: "2025-03-22",
    status: "completed_with_issues",
    totalRequested: 8,
    totalFound: 5,
    totalMissing: 2,
    totalAmbiguous: 1,
    items: [
      {
        id: "tr2-i1",
        requestedDescription: "Amazon DE VAT фактура за Януари 2025",
        requestedDocumentType: "invoice_inbound",
        requestedDocumentNumber: null,
        requestedDocumentDate: "2025-01-10",
        requestedCounterparty: "Amazon",
        status: "found",
        matchedDocumentId: "d7",
        matchNotes: null,
        candidateDocumentIds: [],
      },
      {
        id: "tr2-i2",
        requestedDescription: "Stripe отчет Януари 2025",
        requestedDocumentType: "invoice_inbound",
        requestedDocumentNumber: null,
        requestedDocumentDate: "2025-01-31",
        requestedCounterparty: "Stripe",
        status: "found",
        matchedDocumentId: "d8",
        matchNotes: null,
        candidateDocumentIds: [],
      },
      {
        id: "tr2-i3",
        requestedDescription: "Издадена фактура №0234 от 15.02.2025",
        requestedDocumentType: "invoice_outbound",
        requestedDocumentNumber: "0234",
        requestedDocumentDate: "2025-02-15",
        requestedCounterparty: null,
        status: "found",
        matchedDocumentId: "d11",
        matchNotes: null,
        candidateDocumentIds: [],
      },
      {
        id: "tr2-i4",
        requestedDescription: "Revolut извлечение Февруари 2025",
        requestedDocumentType: "bank_statement",
        requestedDocumentNumber: null,
        requestedDocumentDate: "2025-02-28",
        requestedCounterparty: "Revolut",
        status: "found",
        matchedDocumentId: "d10",
        matchNotes: null,
        candidateDocumentIds: [],
      },
      {
        id: "tr2-i5",
        requestedDescription: "Споразумение с Shopify",
        requestedDocumentType: "agreement",
        requestedDocumentNumber: null,
        requestedDocumentDate: null,
        requestedCounterparty: "Shopify",
        status: "found",
        matchedDocumentId: "d9",
        matchNotes: null,
        candidateDocumentIds: [],
      },
      {
        id: "tr2-i6",
        requestedDescription: "Фактура от Amazon FR за Февруари 2025",
        requestedDocumentType: "invoice_inbound",
        requestedDocumentNumber: null,
        requestedDocumentDate: "2025-02-28",
        requestedCounterparty: "Amazon France",
        status: "not_found",
        matchedDocumentId: null,
        matchNotes: "No matching document found in repository for Amazon France invoices",
        candidateDocumentIds: [],
      },
      {
        id: "tr2-i7",
        requestedDescription: "Банково извлечение DSK Януари 2025",
        requestedDocumentType: "bank_statement",
        requestedDocumentNumber: null,
        requestedDocumentDate: "2025-01-31",
        requestedCounterparty: "DSK Bank",
        status: "not_found",
        matchedDocumentId: null,
        matchNotes: "No bank statement from DSK Bank for January 2025 period",
        candidateDocumentIds: [],
      },
      {
        id: "tr2-i8",
        requestedDescription: "Договор с доставчик на рекламни услуги",
        requestedDocumentType: "contract",
        requestedDocumentNumber: null,
        requestedDocumentDate: null,
        requestedCounterparty: null,
        status: "ambiguous",
        matchedDocumentId: null,
        matchNotes: "Multiple potential matches found — advertising services contract could match Shopify or Amazon agreement",
        candidateDocumentIds: ["d9", "d7"],
      },
    ],
  },
  {
    id: "tr3",
    clientId: "c3",
    requestFilename: "NAP_Iskane_2025_027.pdf",
    requestDate: "2025-03-27",
    status: "processing",
    totalRequested: 4,
    totalFound: 2,
    totalMissing: 0,
    totalAmbiguous: 0,
    items: [
      {
        id: "tr3-i1",
        requestedDescription: "Договор за IT поддръжка с Фирма Алфа",
        requestedDocumentType: "contract",
        requestedDocumentNumber: null,
        requestedDocumentDate: null,
        requestedCounterparty: "Фирма Алфа ЕООД",
        status: "found",
        matchedDocumentId: "d13",
        matchNotes: null,
        candidateDocumentIds: [],
      },
      {
        id: "tr3-i2",
        requestedDescription: "Банково извлечение ДСК Март 2025",
        requestedDocumentType: "bank_statement",
        requestedDocumentNumber: null,
        requestedDocumentDate: "2025-03-15",
        requestedCounterparty: "Банка ДСК",
        status: "found",
        matchedDocumentId: "d15",
        matchNotes: null,
        candidateDocumentIds: [],
      },
    ],
  },
];

export const DOCUMENT_TYPE_LABELS: Record<string, string> = {
  invoice_inbound: "Invoice (Inbound)",
  invoice_outbound: "Invoice (Outbound)",
  contract: "Contract",
  bank_statement: "Bank Statement",
  annex: "Annex",
  agreement: "Agreement",
  other: "Other",
};
